import type {Project} from './types.js';

/** Existing persisted projects have no discriminator and remain visible as stories. */
export const isStoryProject = (project: Pick<Project, 'workflow'>): boolean => project.workflow !== 'one_off';
